
import { Fragment, useState } from 'react';
import { CloseSvg } from '../../CommonComponents/svgs/Svgs';
import { GradientBorderSvg } from '../Svgs/CatalogSvgs';
import { containsSpecialChars, getCharacterLimitMessage, getSpecialCharacterMessage, showToastMessage } from '../../../utils/commonFunctions';
import { isEmpty } from 'lodash';
import ConfirmationDialog from '../../CommonComponents/confirmation_dialog/ConfirmationDialog';
import CatalogueService from '../../../service/CatalogueService';

interface CloneCatalogProps {
    data: any;
    name: string;
    onChangeName(value: string): void;
    componentType: string;
    setOpenConfigurationModal: (value: 'Create' | 'Update' | 'Clone' | null) => void;
    setRefreshCatalog: () => void
    modalLoader: boolean
    setModalLoader: React.Dispatch<React.SetStateAction<boolean>>
}

const CloneCatalog = ({ data, name, componentType, setOpenConfigurationModal, onChangeName, setRefreshCatalog, modalLoader, setModalLoader }: CloneCatalogProps) => {
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

    const handleNamechange = (value: string) => {
        const max_length = 26;
        if (containsSpecialChars(value)) {
            const message = getSpecialCharacterMessage()
            showToastMessage('info', message)
        } else if (value.length > max_length) {
            const message = getCharacterLimitMessage(max_length)
            showToastMessage('info', message)
        } else {
            onChangeName(value);
        }
    }

    const handleClone = async () => {
        setModalLoader(true);
        try {
            if (componentType === 'Bus') {
                await CatalogueService.postTemplate(data)
            } else {
                await CatalogueService.addCatalogue(data)
            }
            setRefreshCatalog();
            showToastMessage('success', `${componentType} cloned successfully`);
        } catch (error: any) {
            const message = typeof error?.response?.data === 'string' ? error?.response?.data : error?.response?.data?.message || `Something went wrong while cloning ${componentType}`;
            showToastMessage('error', message)
            setOpenConfigurationModal(null);
            setModalLoader(false);
        }
    }

    return (
        <Fragment>
            <div className="create-payload small">
                <div className="cp-header">
                    <div className="cp-header-title">
                        Clone {componentType}
                    </div>
                    <div onClick={() => setOpenConfirmationDialog(true)}>
                        <CloseSvg />
                    </div>
                </div>
                <div><GradientBorderSvg /></div>
                <div className="cp-body">
                    <div className="w-100 d-flex flex-row gap-2">
                        <div className="w-100 d-flex flex-column">
                            <div className="cp-text">Name</div>
                            <div>
                                <input type="text" className="form-control"
                                    placeholder="Name"
                                    value={name}
                                    onChange={(e) => {
                                        const inputValue = e.target.value.trimStart();
                                        handleNamechange(inputValue);
                                    }} />
                            </div>
                        </div>
                    </div>
                </div>

                <div><GradientBorderSvg /></div>
                <div className="cp-footer">
                    <div>
                        <button className="d-flex align-items-center btn btn-outline-danger pt-1 pb-1 pe-4 ps-4 fs-14 btn btn-outline-danger"
                            onClick={() => setOpenConfirmationDialog(true)}>
                            Cancel
                        </button>
                    </div>
                    <div>
                        <button
                            className={`d-flex align-items-center btn btn-primary gap-2 fs-14 catalog-create-btn`}
                            onClick={handleClone}
                            disabled={isEmpty(name) || modalLoader}
                        >
                            {modalLoader ? `Cloning` : 'Clone'} {modalLoader && <div className="spin__loader" />}
                        </button>
                    </div>
                </div>
            </div>
            <ConfirmationDialog
                type='cancel'
                title={`Exit ${componentType} Clone`}
                open={openConfirmationDialog}
                description={`All settings will be lost. Are you sure you want to exit?`}
                onCancel={() => {
                    setOpenConfirmationDialog(false)
                }}
                onConfirm={() => {
                    setOpenConfigurationModal(null);
                    setOpenConfirmationDialog(false)
                }}
                confirm_button_text={`Exit`}
            />
        </Fragment>
    )
}

export default CloneCatalog